// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".md-field{border-radius:5px}.qr-code{align-items:center;background:#f9fafc;display:flex;justify-content:center;padding:3.75rem}@media print,screen and (max-width:59.93625em){.qr-code{padding:.625rem}}.qr-code canvas{background:#fff;padding:20px}.v--modal>.share-order{display:block;padding:1.625rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
